import axiosInstance from '../helpers/axiosInstance'

const BASE = `${process.env.REACT_APP_PLATFORM_URL}/api/v1/coverage-events`

export const previewCoverageEvent = async ({ warehouse_id, filters }) => {
  const res = await axiosInstance.post(`${BASE}/preview`, { warehouse_id: parseInt(warehouse_id), filters })
  return res.data
}

export const createCoverageEvent = async ({ warehouse_id, filters, merchant_signature_required }) => {
  const body = { warehouse_id: parseInt(warehouse_id), filters }
  if (merchant_signature_required != null) body.merchant_signature_required = merchant_signature_required
  const res = await axiosInstance.post(BASE, body)
  return res.data
}

export const fetchCoverageEvents = async (params = {}) => {
  const res = await axiosInstance.get(BASE, { params })
  return res.data
}

// params: { state, page, per_page } — the detail response is paginated and filterable
// server-side (five row states), so callers pass through whatever the table needs.
export const fetchCoverageEvent = async (id, params = {}) => {
  const res = await axiosInstance.get(`${BASE}/${id}`, { params })
  return res.data
}

export const fetchCoverageEventDrift = async id => {
  const res = await axiosInstance.get(`${BASE}/${id}/drift`)
  return res.data
}

export const addCoverageEventLocations = async (id, warehouse_location_ids) => {
  const res = await axiosInstance.post(`${BASE}/${id}/locations`, { warehouse_location_ids })
  return res.data
}

export const closeCoverageEvent = async id => {
  const res = await axiosInstance.put(`${BASE}/${id}/close`)
  return res.data
}

export const cancelCoverageEvent = async id => {
  const res = await axiosInstance.put(`${BASE}/${id}/cancel`)
  return res.data
}

export const fetchCoverageEventDifferences = async id => {
  const res = await axiosInstance.get(`${BASE}/${id}/differences`)
  return res.data
}

export const executeCoverageEvent = async (id, proposal_fingerprint) => {
  const res = await axiosInstance.put(`${BASE}/${encodeURIComponent(String(id))}/execute`, { proposal_fingerprint })
  return res.data
}

// params: { page, per_page }; the endpoint also filters by kind/outcome, not surfaced in Phase 5.
export const fetchCoverageEventReconciliation = async (id, params = {}) => {
  const res = await axiosInstance.get(`${BASE}/${encodeURIComponent(String(id))}/reconciliation`, { params })
  return res.data
}

// A stalled multipart PUT must not hold the record-signature modal and the panel lock for ever.
// A timeout rejects without a response, which the dialog maps to UNEXPECTED and answers with its
// bounded read-back (the signature may still have landed).
export const UPLOAD_TIMEOUT_MS = 5 * 60 * 1000

// The staff-recorded signature travels as multipart (the evidence files go through Rails the way
// the supplier-invoice upload does). The files are appended as `evidence[]` so Rails reads an
// array whatever their count, and the fingerprint rides along with the note so the platform binds
// the signature to the proposal the operator saw — never to "the current one".
export const recordCoverageEventSignature = async (id, { proposal_fingerprint, note, evidence }) => {
  const formData = new FormData()
  formData.append('proposal_fingerprint', proposal_fingerprint)
  formData.append('note', note)
  for (const file of evidence) formData.append('evidence[]', file, file.name)
  const res = await axiosInstance.put(`${BASE}/${encodeURIComponent(String(id))}/record-signature`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
    timeout: UPLOAD_TIMEOUT_MS,
  })
  return res.data
}
